import { Button } from "@mui/material";
import { IconDownload } from "@tabler/icons";
import { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { TailSpin } from "react-loader-spinner";
import { adminAxiosInstance } from "src/api/axios";

export default function CSVButton({
  transformer,
  csv_download_url,
  filename,
  data_key,
  csvData,
  setCsvData,
  direct,
  headers,
}) {
  const ref = useRef(null);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (csvData.length && !direct) {
      console.log("clicked");
      ref.current.link.click();
      setCsvData([]);
    }
    console.log(csvData);
    console.log(direct);
  }, [csvData]);

  const download = async () => {
    setLoader(true);

    try {
      const response = await adminAxiosInstance.get(csv_download_url);
      let data = response.data;

      if (data_key) {
        data = data[data_key];
      }

      console.log(data_key, data);
      const transformedData = transformer(data);
      setCsvData(transformedData);

      // Trigger download after setting data
      if (ref.current && csvData.length) {
        setTimeout(() => {}, 500);
      }
    } catch (error) {
      console.error("Error fetching CSV data:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Button
      variant="contained"
      sx={{ display: "flex", flexDirection: "column" }}
      onClick={
        !direct
          ? download
          : () => {
              ref.current.link.click();
            }
      }
    >
      <CSVLink
        ref={ref}
        data={csvData}
        filename={filename}
        onClick={(event) => {
          event.stopPropagation(); // Prevent button click propagation
        }}
        style={{
          width: "6rem",
          marginTop: "5px",
          display: "flex",
          color: "#fff",
          justifyContent: "center",
          textDecoration: "none",
          pointerEvents: "none",
        }}
      />
      {loader ? (
        <TailSpin
          color="#DEE9ECFF"
          height="16px"
          width="16px"
          style={{ margin: "auto", alignSelf: "center" }}
        />
      ) : (
        <>
          <IconDownload />
          <span> Save CSV</span>
        </>
      )}
    </Button>
  );
}
